import React, { useEffect } from 'react';

// A dedicated list for all your portfolio items.
// You can add as many projects as you want here.
const allPortfolioItems = [
  { img: "https://images.pexels.com/photos/3280728/pexels-photo-3280728.png", title: "Streetwear Jacket" },
  { img: "https://images.pexels.com/photos/10460442/pexels-photo-10460442.jpeg", title: "Summer Collection" },
  { img: "https://images.pexels.com/photos/7959624/pexels-photo-7959624.jpeg", title: "Formal Suit Design" },
  { img: "https://images.pexels.com/photos/1154861/pexels-photo-1154861.jpeg", title: "Activewear Line" },
  { img: "https://images.pexels.com/photos/1488463/pexels-photo-1488463.jpeg", title: "Denim & Jeans Fit" },
  { img: "https://images.pexels.com/photos/2043590/pexels-photo-2043590.jpeg", title: "Children's Wear" },
];


function PortfolioPage() {

  // This will set the browser tab title
  useEffect(() => {
    document.title = "Portfolio - Techpack Creators";
  }, []);

  return (
    // We add padding-top (pt-32) to make space for the fixed navbar
    <div className="min-h-screen bg-gradient-to-r from-pink-100 to-pink-200 py-16 pt-32">
      <div className="container mx-auto px-6 text-center">
        
        <h1 className="text-5xl font-bold mb-16 font-montserrat">
          Our Portfolio
        </h1>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-7xl w-full mx-auto">
          {allPortfolioItems.map((item, index) => (
            <div key={index} className="relative group overflow-hidden rounded-2xl shadow-lg">
              <img src={item.img} alt={item.title} className="w-full h-80 object-cover transform group-hover:scale-110 transition duration-500" />
              <div className="absolute inset-0 bg-black/50 flex items-center justify-center opacity-0 group-hover:opacity-100 transition duration-500">
                <h3 className="text-white text-xl font-bold">{item.title}</h3>
              </div>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
}

export default PortfolioPage;